import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';

/** A small dot on a section heading: one of its pages has something to look at.
 *  Decorative; the heading's name says "has updates". */
export default function NavSectionDot({ className = '' }: { className?: string }) {
  const { theme } = useTheme();
  return (
    <span
      data-testid="nav-section-dot"
      aria-hidden="true"
      className={`h-2 w-2 shrink-0 rounded-full ${className}`}
      style={{ background: NAV_THEMES[theme].warn }}
    />
  );
}
